import React, { useState } from "react";

import BookingForm from "../../components/Forms/BookingForm";
import Wrapper from "../../components/Wrapper";
import { Accordion, ButtonGroup, Card, Col, Row, ToggleButton } from "react-bootstrap";
import { bookingTranslations } from "../../ui/src/translations";

function BookTest() {
  const [testType, setTestType] = useState("SOIL");
  const [language, setLanguage] = useState("en");

  const t = (key) =>
    bookingTranslations[language]?.[key] ??
    bookingTranslations.en[key] ??
    key;

  return (
    <Wrapper>
      <div className="d-flex justify-content-end mb-3">
        <ButtonGroup size="sm">
          <ToggleButton
            id="lang-en"
            type="radio"
            variant={language === "en" ? "success" : "outline-success"}
            checked={language === "en"}
            value="en"
            onChange={() => setLanguage("en")}
          >
            English
          </ToggleButton>

          <ToggleButton
            id="lang-hi"
            type="radio"
            variant={language === "hi" ? "success" : "outline-success"}
            checked={language === "hi"}
            value="hi"
            onChange={() => setLanguage("hi")}
          >
            हिन्दी
          </ToggleButton>
        </ButtonGroup>
      </div>
      <Row className="g-3">
        {/* Form section */}
        <Col lg={8} className="r-5 order-2 order-lg-1">
          <Card>
            <h2 className="fw-bolder">{t("bookingForm")}</h2>
            <BookingForm onTestTypeChange={setTestType} language={language} />
            {/* <BookingFormikForm route='/' info={partnerInfo} /> */}
          </Card>
        </Col>
        {testType === 'SOIL' && (
          <Col className="order-1 order-lg-2">
            <div className="card-wrapper">
              <Card>
                <h2 className="fw-bolder mb-3">{t("bookingGuidelines")}</h2>

                <Accordion defaultActiveKey="0" flush>
                  <Accordion.Item eventKey="0">
                    <Accordion.Header>{t("selectTestType")}</Accordion.Header>
                    <Accordion.Body>
                      <ul className="mb-0">
                        <li>{t("selectTestTypeDesc1")}</li>
                        <li>{t("selectTestTypeDesc2")}</li>
                      </ul>
                    </Accordion.Body>
                  </Accordion.Item>

                  <Accordion.Item eventKey="1">
                    <Accordion.Header>{t("fillSampleDetails")}</Accordion.Header>
                    <Accordion.Body>
                      <ul className="mb-0">
                        <li>{t("fillSampleDetailsDesc1")}</li>
                        <li>{t("fillSampleDetailsDesc2")}</li>
                        <li>{t("fillSampleDetailsDesc3")}</li>
                        <li>{t("fillSampleDetailsDesc4")}</li>
                      </ul>
                    </Accordion.Body>
                  </Accordion.Item>

                  <Accordion.Item eventKey="2">
                    <Accordion.Header>{t("multipleSamples")}</Accordion.Header>
                    <Accordion.Body>
                      <ul className="mb-0">
                        <li>{t("multipleSamplesDesc1")}</li>
                        <li>{t("multipleSamplesDesc2")}</li>
                        <li>{t("multipleSamplesDesc3")}</li>
                      </ul>
                    </Accordion.Body>
                  </Accordion.Item>

                  <Accordion.Item eventKey="3">
                    <Accordion.Header>{t("bookingPhotosOptional")}</Accordion.Header>
                    <Accordion.Body>
                      <li>{t("bookingPhotosDesc1")}</li>
                      <li>{t("bookingPhotosDesc2")}</li>
                      <li>{t("bookingPhotosDesc3")}</li>
                    </Accordion.Body>
                  </Accordion.Item>

                  <Accordion.Item eventKey="4">
                    <Accordion.Header>{t("beforeSubmitting")}</Accordion.Header>
                    <Accordion.Body>
                      <ul className="mb-0">
                        <li>{t("beforeSubmittingDesc1")}</li>
                        <li>{t("beforeSubmittingDesc2")}</li>
                        <li>{t("beforeSubmittingDesc3")}</li>
                      </ul>
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>
              </Card>
            </div>
          </Col>
        )}
      </Row>
    </Wrapper>
  );
}

export default BookTest;
